import React from 'react';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { ProductDataForm } from '../../../app/models/Product';
import { Unit } from '../../../app/models/Unit';
import { ItemCategory } from '../../../app/models/ItemCategory';
import { Location } from '../../../app/models/Location';
import { Sector } from '../../../app/models/Sector';
import { Quality } from '../../../app/models/Quality';
import { Color } from '../../../app/models/Color';
import ProductForm from './forms/ProductForm';

type SelectOpt = { id: number | string; name: string };

interface Props {
  fetching?: boolean;
  action: () => void;
  cancel: () => void;
  product: ProductDataForm;
  setProduct: (product: ProductDataForm) => void;
  units: Unit[];
  ownershipTypes: SelectOpt[];
  taxes: SelectOpt[];
  sectors: Sector[];
  categories: ItemCategory[];
  locations: Location[];
  qualities: Quality[];
  colors: Color[];
  errorFields?: any;
  is_edit?: boolean;
}

const ProductFormContainer = ({
  fetching,
  action,
  cancel,
  product,
  setProduct,
  units,
  ownershipTypes,
  taxes,
  sectors,
  categories,
  locations,
  qualities,
  colors,
  errorFields = null,
  is_edit = false
}: Props) => {
  return (
    <>
      <div className="row">
        <div className="col-12">
          <ProductForm
            productDataForm={product}
            setProductDataForm={setProduct}
            units={units}
            ownershipTypes={ownershipTypes}
            taxes={taxes}
            sectors={sectors}
            categories={categories}
            locations={locations}
            qualities={qualities}
            colors={colors}
            errorFields={errorFields}
            is_edit={is_edit}
          />
        </div>
      </div>
      <hr />
      <div className="row justify-content-end">
        <div className="col-auto">
          <ButtonCancelForm callbackCancel={cancel} locked={fetching} />
        </div>
        <div className="col-auto">
          <ButtonSaveForm callbackSave={action} locked={fetching} />
        </div>
      </div>
    </>
  );
};

export default ProductFormContainer;
